import { render, staticRenderFns } from "./updatecut.vue?vue&type=template&id=5c54cd38&"
import script from "./updatecut.vue?vue&type=script&lang=js&"
export * from "./updatecut.vue?vue&type=script&lang=js&"
import style0 from "./updatecut.vue?vue&type=style&index=0&id=5c54cd38&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports